import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormControl} from '@angular/forms';
import {first, map, startWith, takeUntil} from 'rxjs/operators';
import {MatSelectChange} from '@angular/material/select';
import {Contract} from '../../interface/contract';
import {Observable, ReplaySubject} from 'rxjs';
import {PartnerService} from '../../services/partner.service';
import {ListResponse} from '../../interface/response/list-response';
import {ContractService} from '../../services/contract.service';
import {CommissionSettlement} from "../../interface/commission-settlement";
import {CommissionSettlementService} from "../../services/commission-settlement.service";
import {CountedAndPaginated} from "../../interface/response/counted-and-paginated";
import {InsuranceCompany} from "../../interface/insurance-company";
import {IC_PZU} from "../../services/insurance-company.service";
import {Dictionary} from "../../interface/dictionary";
import {CommissionContractSettlement} from "../../interface/commission-contract-settlement";
import {COMMISSION_SETTLEMENT_STATUS_NEW, COMMISSION_SETTLEMENT_STATUS_SETTLED} from "../../services/dict.service";
import {on} from "@ngrx/store";
import {Partner} from "../../interface/partner";

@Component({
  selector: 'app-dict-commission-settlement',
  templateUrl: './dict-commission-settlement.component.html',
  styleUrls: ['./dict-commission-settlement.component.scss']
})
export class DictCommissionSettlementComponent implements OnInit, OnDestroy, ControlValueAccessor, OnChanges {
  @Input() label: string;
  @Input() multiple = false;
  @Input() control: FormControl = null;
  @Input() required = false;
  @Input() commissionSettlement: CommissionSettlement[] = [];
  @Input() commissionSettlementStatus?: string;
  @Input() excludeId?: string;
  @Input() showOwnerName = false;
  @Input() showStatus = false;
  @Input() initializeWith = null;
  @Input() filterPartnership = false;
  @Output() selectedCommissionSettlement: EventEmitter<CommissionSettlement[]> = new EventEmitter<CommissionSettlement[]>();
  externalControl = true;
  disabled = false;
  items: CommissionSettlement[] = [];
  filteredItems: CommissionSettlement[] = [];
  partner?: Partner = null;
  value?: number = null;



  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private partnerService: PartnerService,
    private commissionSettlementService: CommissionSettlementService,
  ) {
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  ngOnInit(): void {
    if (this.control === null) {
      this.control = new FormControl('');
      this.externalControl = false;
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (this.externalControl) {
      return;
    }

    this.control.setValue(value);
    this.value = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.selectedCommissionSettlement.emit(e.value);
    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue(this.multiple ? [] : '');
    this.writeValue(this.multiple ? [] : '');
    this.onChange(this.value);
  }
  ngOnChanges(): void {
    // this.filteredItems = this.commissionSettlement;
    this.filteredItems = this.commissionSettlement?.sort((a: CommissionSettlement, b: CommissionSettlement) =>
      new Date(a.billingMonth).getTime() - new Date(b.billingMonth).getTime());
  }
}
